var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124.47,
    height: 125.404,
    viewBox: "0 0 124.47 125.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5294",
    "data-name": "Rectangle 5294",
    width: 124.47,
    height: 125.404,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9795",
    "data-name": "Group 9795",
    transform: "translate(-324 169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9794",
    "data-name": "Group 9794",
    transform: "translate(324 -169)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27699",
    "data-name": "Path 27699",
    d: "M68.809,103.628a6.574,6.574,0,1,1-6.574-6.574,6.574,6.574,0,0,1,6.574,6.574",
    transform: "translate(0 -5)",
    fill: "#e62e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27700",
    "data-name": "Path 27700",
    d: "M62.235,94.319a6.655,6.655,0,0,1-6.655-6.655L53.7,53.857c0-3.676,4.857-6.655,8.533-6.655s8.533,2.979,8.533,6.655L68.89,87.664a6.655,6.655,0,0,1-6.655,6.655",
    transform: "translate(0 -5)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27701",
    "data-name": "Path 27701",
    d: "M61.837,11.339l51.294,102.726-101.793-.021ZM61.837,0H61.8a11.337,11.337,0,0,0-10.14,6.336L1.163,109.041a11.34,11.34,0,0,0,10.173,16.342l101.793.021h0A11.338,11.338,0,0,0,123.275,109L71.981,6.273A11.338,11.338,0,0,0,61.837,0",
    fill: "#e62e2e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/DefaultIcon.4f87e6cd6f77c1b640c0b4a4b7b60bfa.svg";
export { ForwardRef as ReactComponent };